import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { HttpLink } from 'apollo-link-http'
import { onError } from 'apollo-link-error'
import { ApolloLink } from 'apollo-link'
import fragmentMatcher from './fragmentMatcher'

// Relative so it goes through whichever /cms proxy serves the page (express.json in prod, the dev server locally)
const BASE_URL = '/cms/gql'

const client = new ApolloClient({

	link: ApolloLink.from([
		onError(({ graphQLErrors, networkError }) => {
			if(graphQLErrors) {
				graphQLErrors.forEach(({ message, locations, path }) => {
					console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
				})
			}
			if(networkError) {
				console.log(`[Network error]: ${networkError}`)
			}
		}),
		new HttpLink({
			uri: BASE_URL,
			credentials: 'same-origin'
		})
	]),

	cache: new InMemoryCache({ fragmentMatcher })

})

export default client



// WEBPACK FOOTER //
// ./src/components/CraftQL/index.js